import styled from "styled-components";
import { ButtonSettings, Text } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const PromotionPageStyled = styled.section`
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
  &::before {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    // background-color: #000;
    opacity: 0.3;
  }
`;

export const TextStyled = styled(Text)`
  font-weight: normal;
  margin-bottom: ${props => props.theme.spacing.small};
  ${props => props.bold && `font-weight: ${props.theme.font.weight.bold}`}
`;

export const PromotionContainerStyled = styled.article`
  position: relative;
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: ${props => props.theme.font.size.default};
  padding: ${props => props.theme.spacing.large} 0;
  height: auto;
  margin: 0 auto;
  background-color: rgba(8, 33, 37, 0.97);
  color: ${props => props.theme.color.white};
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  margin-top: ${props => props.theme.spacing.medium};
  width: ${props => (props.userLocale === "fr" ? "44vw" : "35.54vw")};
  border-radius: 0.5rem;
  background-color: ${props => `rgba(${props.theme.color.blackRGB}, 0.3)`};
`;

export const LogoContainerStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing.large};
`;

export const LogoStyled = styled.div`
  display: block;
  ${props => props.inlineBlock && `display: inline-block`}
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "margin-right" : "margin-left")}: ${props =>
  props.theme.spacing.large};
`;

export const SecondaryLogoStyled = styled.img`
  ${props => props.inlineBlock && `display: inline-block`}
  vertical-align: middle;
  & + & {
    margin: 0 15px;
  }
`;
